import type { RequestConfig } from '@customTypes/index';
import type { PaginatedResponse, SearchClubItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type SearchClubsParams = RequestConfig;

export const searchClubs = async ({ config }: SearchClubsParams) =>
  api.get<PaginatedResponse<SearchClubItemDto[]>>(`/api/search/clubs`, config);
